<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-delegate-page">
  <div class="org-admin-delegate-page--layout">
    <app-org-admin-sidebar class="org-admin-delegate-page--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-delegate-page--content">
      <app-page-header></app-page-header>
      <div class="delegate-container">
        <lib-manage-delegates
          tabStorageScope="org-admin"
          [ownersOnly]="ownersOnly"
          [activeOwnerId]="activeDelegatedOwnerId"
          [scopeOptions]="orgAdminScopeOptions"
          (addDelegate)="onDelegateCreated()"
          (deleteDelegate)="onDelegateDeleted()"
          (withdrawOwner)="onAccessRevoked($event)"
          (switchOwner)="onSwitchOwner($event)"
          (requestOwner)="onRequestOwner($event)"
        ></lib-manage-delegates>
      </div>
    </div>
  </div>
</div>
